import React, { useState } from 'react';
import Dashboard from './components/Dashboard';
import Objects from './components/Objects';
import Offers from './components/Offers';
import Invoices from './components/Invoices';
import References from './components/References';
import Commissions from './components/Commissions';
import UserManagement from './components/UserManagement';
import Documents from './components/Documents';

function App() {
    const [activeView, setActiveView] = useState('Dashboard');

    return (
        <div>
            <nav className="topnav">
                <button type="button" onClick={() => setActiveView('Dashboard')}>Dashboard</button>
                <button type="button" onClick={() => setActiveView('Objects')}>Objekte</button>
                <button type="button" onClick={() => setActiveView('Offers')}>Angebote</button>
                <button type="button" onClick={() => setActiveView('Invoices')}>Rechnungen</button>
                <button type="button" onClick={() => setActiveView('Documents')}>Dokumente</button>
                <button type="button" onClick={() => setActiveView('References')}>Referenzen</button>
                <button type="button" onClick={() => setActiveView('Commissions')}>Provisionen</button>
                <button type="button" onClick={() => setActiveView('UserManagement')}>Benutzerverwaltung</button>
            </nav>

            <main className="page-content">
                {activeView === 'Dashboard' && <Dashboard />}
                {activeView === 'Objects' && <Objects />}
                {activeView === 'Offers' && <Offers />}
                {activeView === 'Invoices' && <Invoices />}
                {activeView === 'Documents' && <Documents />}
                {activeView === 'References' && <References />}
                {activeView === 'Commissions' && <Commissions />}
                {activeView === 'UserManagement' && <UserManagement />}
            </main>
        </div>
    );
}

export default App;
